import React from 'react';
import AppBar from 'components/app-bar/app-bar';

export default function LecturesPage() {
  return <AppBar title="Lectures"></AppBar>;
}
